<template>
  <div class="">
    <PreLoader v-if="isLoading" />

    <GrantsConstraintsPlanForm
      v-if="!isLoading"
      :grantsConstraintsPlan="grantsConstraintsPlan"
      v-on:addOrUpdateGrantsConstraintsPlans="addOrUpdateGrantsConstraintsPlans"
      :submitName="$t('add')"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import { STATUS } from "@/utils/constants";
import GrantsConstraintsPlanForm from "@/components/settings/settingsSalary/grantsConstraintsPlans/GrantsConstraintsPlanForm.vue";
import GrantsConstraintsPlan from "@/models/settings/settingsSalary/grantsConstraintsPlans/GrantsConstraintsPlan";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  mixins: [createToastMixin],
  components: {
    PreLoader,
    GrantsConstraintsPlanForm,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      grantsConstraintsPlan: new GrantsConstraintsPlan(),
    };
  },
  methods: {
    async addOrUpdateGrantsConstraintsPlans() {
      this.isLoading = true;
      try {
        let response =
          await this.grantsConstraintsPlan.addOrUpdateGrantsConstraintsPlans(
            this.language,
            this.userAuthorizeToken
          );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.grantsConstraintsPlan.setInitialValue();
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {},
};
</script>
